<!-- パタカ選択画面 -->

<template>
  <div class="whole-wrap whole-wrap--gray">
    <!-- PC -->
    <template v-if="isWideScreen">
      <BurgerMenuComponentPC
      @end="handleSubject"
      :isBackProcess="true"
      :isTitle="$t('app.title')"
      />
      <!-- Top -->
      <div class="pc-select">
        <div class="select-top">
          <div class="select-top-detail">
            <div class="select-top-details">
              <div class="select-top-detail-elements select-top-detail-elements--name"
              :class="subject_name === '' ? 'select-top-detail-elements--none':''">
                {{subject_name===""?$t('subject.no_name'):subject_name + ' ' + $t('subject.honorific')}}
              </div>
              <div class="flex flex justify-content-center">
                <div class="select-top-detail-id">
                  <div class="select-top-detail-elements select-top-detail-elements--id">{{ subject_id }}</div>
                  <div class="flex justify-content-center">
                    <div class="select-top-detail-elements select-top-detail-elements--gender"
                    :class="gender === 0?'select-top-detail-elements--none':''">
                      {{ genderText }}
                    </div>
                    <div class="select-top-detail-elements select-top-detail-elements--age"
                    :class="age ==='000'?'select-top-detail-elements--none':''">
                      {{ age==="000"?$t('subject.age'):age + $t('subject.years_old_suffix') }}
                    </div>
                  </div>
                </div>
                <div class="select-top-detail-pataka">
                  <div class="select-top-detail-elements select-top-detail-elements--pataka">{{ $t('test_list.pataka_measurement') }}</div>
                  <div class="flex justify-content-center mt-4">
                    <div @click="toggleModal" class="select-top-detail-elements select-top-detail-elements--secound flex justify-content-center">
                      <div class="secound-icon"></div>
                      {{ measurementTypeText }}{{ $t('settings.seconds_suffix') }}
                    </div>
                    <div @click="toggleModal" v-if="useAnalaysisFlag" class="select-top-detail-elements select-top-detail-elements--analysis flex justify-content-center">
                      <div class="analysis-icon" :class="analysisTypeFlag === '2'?'analysis-icon--on':'analysis-icon--off'"></div>
                      {{analysisTypeFlag === '2'?$t('patk_test.clarity_on'):$t('patk_test.clarity_off')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="select-top-text" v-html="$t('test_list.confirm_and_start')"></div>
            <div class="select-top-img"></div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="select-body">
          <!-- パタカ回数測定 -->
          <div class="flex justify-content-center">
            <div class="select-body-title mt-16">
              <div class="small-title">PaTaKa</div>
              <div class="big-title">{{ $t('test_list.test_name_patk') }}</div>
            </div>
            <div class="select-body-elements mt-16">
              <div v-for="measure in measurements"
              :key="measure.type"
              class="select-body-elements-detitle"
              :class="['select-item', { 'select-item--active': measure.isCompleted }, { [`select-item--${measure.type}`]: true }]">
                <div class="select-item-top">
                  <div class="select-item-what-audio" :class="[`select-item-what-audio--${measure.type}`]"></div>
                  <div>
                    <div class="select-item-status">{{ measure.isCompleted ? $t('test_list.status_completed') : $t('test_list.status_not_tested')}}</div>
                    <div class="select-item-date" :class="measure.isCompleted?'select-item-date--completed':''">{{ 
                      measure.dateVal ? formatDate(new Date(measure.dateVal)) : $t('test_list.date_placeholder')
                    }}</div>
                    <div class="select-item-time select-item-time--pc" :class="measure.isCompleted?'select-item-time--completed':''">{{
                      measure.dateVal ? formatTime(new Date(measure.dateVal)) : '- - : - -'
                    }}</div>
                  </div>
                  <div v-if="measure.isCompleted" class="btn select-item-pc select-item-pc--restart" @click="handleMeasurement(measure.type)">
                    {{ $t('test_list.retry_measurement') }}
                    <div  class=" select-item-measure-icon select-item-measure-icon--restart"></div>
                  </div>
                  <div v-else class="btn select-item-pc select-item-pc--start" @click="handleMeasurement(measure.type)">
                    {{ $t('test_list.action_start_test') }}
                    <div class="select-item-measure-icon select-item-measure-icon--start"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- トータル発音回数 -->
            <div class="select-body-result ml-16">
              <div class="result-title">{{ $t('test_list.total_count') }}</div>
              <div class="result-detail">
                <div v-for="measure in measurements" :key="measure.type" class="result-detail-column"
                :class="measure.type==='ta'?'result-detail-column--ta':''">
                  <div v-if="measure.isCompleted" :class="['column-text',{ [`column-text--${measure.type}`]: true }]">
                    <span class="column-text-number">{{measure.vocabCount}}</span>
                    <span class="ml-4 en-ml-0">{{ $t('test_list.times') }}</span>
                  </div>
                  <div v-else class="column-text column-text--nomal">
                    <span>{{ $t('test_list.status_not_tested') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 1秒あたり -->
            <div class="select-body-result ml-8">
              <div class="result-title">{{ $t('test_list.per_second') }}</div>
              <div class="result-detail">
                <div v-for="measure in measurements" :key="measure.type" class="result-detail-column"
                :class="measure.type==='ta'?'result-detail-column--ta':''">
                  <div v-if="measure.isCompleted" :class="['column-text',{ [`column-text--${measure.type}`]: true }]">
                    <span class="column-text-number">{{measure.vocabPerSecond}}</span>
                    <span class="ml-4">{{ $t('test_list.times') }}</span>
                  </div>
                  <div v-else class="column-text column-text--nomal">
                    <span>{{ $t('test_list.status_not_tested') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div  class="select-body-border"></div>
          <!-- オーラルフレイルセルフチェック -->
          <div  class="flex justify-content-center">
            <div class="select-body-title mt-16">
              <div class="small-title">OF-5</div>
              <div class="big-title" v-html="$t('test_list.test_name_oral_frailty')"></div>
            </div>
            <div class="select-body-elements mt-16">
              <div v-for="oralFrailty in oralFrailtys"
              :key="oralFrailty.type"
              class="select-body-elements-detitle"
              :class="['select-item', { 'select-item--active': oralFrailty.isCompleted }, { [`select-item--${oralFrailty.type}`]: true }]">
                <div class="select-item-top">
                  <div class="select-item-what-audio select-item-what-audio--of"></div>
                  <div>
                    <div class="select-item-status">{{ oralFrailty.isCompleted ? $t('test_list.status_completed') : $t('test_list.status_not_tested') }}</div>
                    <div class="select-item-date" :class="oralFrailty.isCompleted ? 'select-item-date--completed':''">{{
                      oralFrailty.dateVal ? formatDate(new Date(oralFrailty.dateVal)) : $t('test_list.date_placeholder')
                    }}</div>
                    <div class="select-item-time select-item-time--pc" :class="oralFrailty.isCompleted ? 'select-item-time--completed':''">{{
                      oralFrailty.dateVal ? formatTime(new Date(oralFrailty.dateVal)) : '- - : - -'
                    }}</div>
                  </div>
                  <div v-if="oralFrailty.isCompleted" class="btn select-item-pc select-item-pc--restart" @click="handleMeasurement('of')">
                    {{ $t('test_list.retry_measurement') }}
                    <div  class=" select-item-measure-icon select-item-measure-icon--restart"></div>
                  </div>
                  <div v-else class="btn select-item-pc select-item-pc--start" @click="handleMeasurement('of')">
                    {{ $t('test_list.action_start_test') }}
                    <div class="select-item-measure-icon select-item-measure-icon--start"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- オーラルフレイル -->
            <div class="select-body-result ml-16">
              <div class="result-title">{{ $t('test_list.oral_frailty_pc') }}</div>
              <div class="result-detail result-detail--of">
                <div v-for="oralFrailty in oralFrailtys"
                :key="oralFrailty.type"
                class="result-detail-column result-detail-column--of">
                  <div v-if="oralFrailty.isCompleted" class="column-text column-text--of">
                    {{oralFrailty.result ? $t('test_list.at_risk') : $t('test_list.not_at_risk') }}
                  </div>
                  <div v-else class="column-text column-text--nomal">
                    <span>{{ $t('test_list.status_not_tested') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 該当項目 -->
            <div class="select-body-result ml-8">
              <div class="result-title">{{ $t('test_list.oral_frailty_items_checked') }}</div>
              <div class="result-detail result-detail--of">
                <div v-for="oralFrailty in oralFrailtys"
                :key="oralFrailty.type"
                class="result-detail-column">
                  <div v-if="oralFrailty.isCompleted" class="column-text column-text--of-number">
                    <span class="column-text-number">{{oralFrailty.score}}</span>
                    <span class="ml-4">{{ $t('test_list.items_out_of_5') }}</span>
                  </div>
                  <div v-else class="column-text column-text--nomal">
                    <span>{{ $t('test_list.status_not_tested') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="select-body-border"></div>
        </div>
        <div class="flex justify-content-center mt-56">
          <div :class="[{ btn: isShowResult }, 'btn btn-base-report', { 'btn-base-report--inactive': !isShowResult },]" @click="handleShowResult">
            <div class="btn-base-report-text">{{ $t('test_list.action_view_report') }}</div>
          </div>
        </div>
        <!-- 画面高さ800未満で表示するスクロール -->
        <div v-if="isScrollFlag" class="pc-scroll">
          <div class="select-scroll-mark mt-10"></div>
        </div>
        <!-- コピーライト -->
        <div class="text-copyright-pc mt-40">© 2025 Lion Corporation. All rights reserved.</div>
        <SavingDialog
        v-if="isSaving"
        :isComplete="isComplete"
        :isEmergency="isEmergency"
        :title="dialogTitle"
        :message="dialogMessage"
        :approval="dialogApproval"
        :rejected="dialogRejected"
        @response="handleDialogResponse"
        />
      </div>
    </template>

    <!-- mobile -->
    <template v-else>
      <BurgerMenuComponent :isGradation="true" />
      <div class="select-page-tops">
        <div class="select-page-top-info">
          <div class="info-colum">
            <div class="info-colum-top">
              <div class="info-colum-top-name" :class="subject_name === '' ? 'inspector-none':''">
                {{subject_name===""?$t('subject.no_name'):subject_name + ' ' + $t('subject.honorific')}}
              </div>
              <div class="info-colum-top-inspector">
                <div class="inspector-id">{{ subject_id }}</div>
                <div class="inspector-ditail">
                  <div class="inspector-ditail-gender" :class="gender === 0?'inspector-none':''">
                    {{ genderText }}
                  </div>
                  <div class="inspector-ditail-age" :class="age ==='000'?'inspector-none':''">
                    {{ age==="000"?$t('subject.age'):age + $t('subject.years_old_suffix') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="info-colum-down">
              <div class="info-colum-down-text">{{ $t('test_list.pataka_measurement') }}</div>
              <div @click="toggleModal" class="info-colum-down-seconds">
                <div class="info-colum-down-second-icon"></div>
                {{ measurementTypeText }}{{ $t('settings.seconds_suffix') }}
              </div>
              <div @click="toggleModal" v-if="useAnalaysisFlag" class="info-colum-down-clarity">
                <div class="info-clarity-icon" :class="analysisTypeFlag === '2'?'info-clarity-icon--on':'info-clarity-icon--off'"></div>
                {{analysisTypeFlag === '2'?$t('patk_test.clarity_on'):$t('patk_test.clarity_off')}}
              </div>
            </div>
          </div>
        </div>
        <div class="application-img-wrap">
          
          <div class="application-img-text">
            <span v-html="$t('test_list.confirm_and_start')"></span>
            <div class="mt-30">
              <div class="select-scroll-mark"></div>
            </div>
          </div>
          <img src="@/assets/img/woman-result.png" alt="" class="application-img" />
        </div>
      </div>
      <div class="select-page">
        <div class="select-page-of">
          <div class="select-page-of select-page-of--en">PaTaKa</div>
          <div class="select-page-of select-page-of--jp">{{ $t('test_list.test_name_patk') }}</div>
        </div>
        <div v-for="measure in measurements" :key="measure.type" :class="['select-item', { 'select-item--active': measure.isCompleted }, { [`select-item--${measure.type}`]: true }]">
          <div class="select-item-top">
            <div class="select-item-what-audio" :class="[`select-item-what-audio--${measure.type}`]"></div>
            <div>
              <div class="select-item-status">{{ measure.isCompleted ? $t('test_list.status_completed') : $t('test_list.status_not_tested')}}</div>
              <div class="select-item-date" :class="measure.isCompleted?'select-item-date--completed':''">{{ 
                measure.dateVal ? formatDate(new Date(measure.dateVal)) : $t('test_list.date_placeholder')
              }}</div>
              <div class="select-item-time" :class="measure.isCompleted?'select-item-time--completed':''">{{
                measure.dateVal ? formatTime(new Date(measure.dateVal)) : '- - : - -'
              }}</div>
            </div>
            <div v-if="measure.isCompleted" class="btn select-item-measure" @click="handleMeasurement(measure.type)">{{ $t('test_list.retry_measurement') }}</div>
            <div v-else class="btn select-item-measure" @click="handleMeasurement(measure.type)">{{ $t('test_list.action_start_test') }}</div>
          </div>
          <div v-if="measure.isCompleted"  :class="['select-item-down',{ [`select-item-down--${measure.type}`]: true }]">
            <div class="select-item-down-detail" :class="[`select-item-down-detail--${measure.type}`]">
              <div class="select-item-detail-title mt-6">{{ $t('test_list.total_count') }}</div>
              <div :class="['select-item-detail-title mt-11',{ [`select-item-detail-title--${measure.type}`]: true }]">
                <span class="select-item-detail-number">{{measure.vocabCount}}</span>
                <span class="ml-4 en-ml-0">{{ $t('test_list.times') }}</span>
              </div>
            </div>
            <div class="select-item-down-detail" :class="[`select-item-down-detail--${measure.type}`]">
              <div class="select-item-detail-title mt-6">{{ $t('test_list.per_second_full') }}</div>
              <div  :class="['select-item-detail-title mt-11',{ [`select-item-detail-title--${measure.type}`]: true }]">
                <span class="select-item-detail-number">{{measure.vocabPerSecond}}</span>
                <span class="ml-4 en-ml-0">{{ $t('test_list.times') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="select-page-of mt-56">
          <div class="select-page-of select-page-of--en">OF-5</div>
          <div class="select-page-of select-page-of--jp" v-html="$t('test_list.test_name_oral_frailty')"></div>
        </div>
        <div v-for="oralFrailty in oralFrailtys"
        :key="oralFrailty.type"
        :class="['select-item', { 'select-item--active': oralFrailty.isCompleted }, { [`select-item--of`]: true }]">
          <div class="select-item-top">
            <div class="select-item-what-audio select-item-what-audio--of"></div>
            <div>
              <div class="select-item-status">{{ oralFrailty.isCompleted ? $t('test_list.status_completed') : $t('test_list.status_not_tested') }}</div>
              <div class="select-item-date" :class="oralFrailty.isCompleted ? 'select-item-date--completed':''">{{
                oralFrailty.dateVal ? formatDate(new Date(oralFrailty.dateVal)) : $t('test_list.date_placeholder')
              }}</div>
              <div class="select-item-time" :class="oralFrailty.isCompleted ? 'select-item-time--completed':''">{{
                oralFrailty.dateVal ? formatTime(new Date(oralFrailty.dateVal)) : '- - : - -'
              }}</div>
            </div>
            <div v-if="oralFrailty.isCompleted" class="btn select-item-measure" @click="handleMeasurement('of')">{{ $t('test_list.retry_measurement') }}</div>
            <div v-else class="btn select-item-measure" @click="handleMeasurement('of')">{{ $t('test_list.action_start_test') }}</div>
          </div>
          <div v-if="oralFrailty.isCompleted" class="select-item-down select-item-down--of">
            <div class="select-item-down-detail select-item-down-detail--of">
              <div class="select-item-detail-title mt-6">{{ $t('test_list.oral_frailty') }}</div>
              <div class="select-item-detail-title mt-13 select-item-detail-title--of">
                <span class="select-item-detail-text">{{oralFrailty.result ? $t('test_list.at_risk') : $t('test_list.not_at_risk') }}</span>
              </div>
            </div>
            <div class="select-item-down-detail select-item-down-detail--of">
              <div class="select-item-detail-title mt-6">{{ $t('test_list.oral_frailty_items_checked') }}</div>
              <div  class="select-item-detail-title mt-6 select-item-detail-title--of">
                <span class="select-item-detail-number">{{oralFrailty.score}}</span>
                <span class="ml-4">{{ $t('test_list.items_out_of_5') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-center mt-80">
          <div :class="[{ btn: isShowResult }, 'btn btn-base-report', { 'btn-base-report--inactive': !isShowResult },]" @click="handleShowResult">
            <div class="btn-base-report-text">{{ $t('test_list.action_view_report') }}</div>
          </div>
        </div>
        <div class="flex justify-content-center mt-16">
          <div class="btn btn-close" @click="handleSubject">
            <div class="btn-close-text">{{ $t('test_list.finish') }}</div>
          </div>
        </div>
        <!-- コピーライト -->
        <div class="text-copyright">© 2025 Lion Corporation. All rights reserved.</div>
        <SavingDialog
        v-if="isSaving"
        :isComplete="isComplete"
        :isEmergency="isEmergency"
        :title="dialogTitle"
        :message="dialogMessage"
        :approval="dialogApproval"
        :rejected="dialogRejected"
        @response="handleDialogResponse"
        />
      </div>
    </template>

    <!-- 設定変更モーダル -->
    <div v-if="isModalVisible" ref="modal" class="modal-wrap">
      <div class="modal-overlay modal-overlay--navy"></div>
      <div class="modal modal--measure-menu">
        <div class="modal-title">{{ $t('settings.individual_settings') }}</div>
        <div class="modal-explain">{{ $t('settings.current_subject_settings') }}</div>
        <div class="form-label mt-41 ml-30">{{ $t('settings.test_duration') }}</div>
        <div class="flex mt-8 ml-30">
          <div class="radio radio--config radio--config--left">
            <input type="radio" id="time5" name="file-kinds" v-model="measurement_type" :value="'1'" :checked="measurement_type === '1'" />
            <label class="u-fz14 u-dark-gray radio-label config-dialog" for="time5">{{ $t('settings.seconds_5') }}</label>
          </div>
          <div class="radio radio--config radio--config--left">
            <input type="radio" id="time10" name="file-kinds" v-model="measurement_type" :value="'2'" :checked="measurement_type === '2'" />
            <label class="u-fz14 u-dark-gray radio-label config-dialog" for="time10">{{ $t('settings.seconds_10') }}</label>
          </div>
        </div>
        <div v-if="useAnalaysisFlag" class="form-label mt-24 ml-30">{{ $t('settings.clarity_analysis') }}</div>
        <div v-if="useAnalaysisFlag" class="flex mt-8 ml-30">
          <div class="radio radio--config radio--config--left">
            <input type="radio" id="analysisYes" name="analysis-kinds" v-model="analysisTypeFlag" :value="'1'" :checked="analysisTypeFlag === '1'" />
            <label class="u-fz14 u-dark-gray radio-label config-dialog" for="analysisYes">{{ $t('settings.off') }}</label>
          </div>
          <div class="radio radio--config radio--config--left">
            <input type="radio" id="analysisNo" name="analysis-kinds" v-model="analysisTypeFlag" :value="'2'" :checked="analysisTypeFlag === '2'" />
            <label class="u-fz14 u-dark-gray radio-label config-dialog" for="analysisNo">{{ $t('settings.on') }}</label>
          </div>
        </div>
        <div class="flex justify-content-center mt-57">
          <div id="modal-save" class="btn btn-base-next" @click="settingUpdate">{{ $t('settings.save') }}</div>
        </div>
        <div class="flex justify-content-center mt-16">
          <div class="btn btn-close btn-close--shadow">
            <div id="modal-cancel" class="btn-close-text" @click="cancelUpdate">{{ $t('settings.cancel') }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 結レポートモーダル -->
    <div v-if="isGeneratingPDF" ref="modal" class="modal-wrap">
      <div class="modal-overlay modal-overlay--navy"></div>
      <div class="modal modal--measure-menu">
        <div class="modal-title mt-20">{{ $t('report.generating') }}</div>
        <div class="modal-text mt-40">
          <ul>
            <li>• {{ $t('report.creating_report') }}</li>
            <li>• {{ $t('report.generating_graph') }}</li>
            <li>• {{ $t('report.saving_pdf') }}</li>
          </ul>
        </div>
        <div class="modal-explain mt-40" style="text-align: center">{{ $t('report.please_wait') }}</div>
      </div>
    </div>
    <ConsentDialog
      v-if="showConsentDialog"
      :isVisible="showConsentDialog"
      @response="(hasConsented) => handleConsentResponse(hasConsented)"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
// import { formatTimeStamp, formatFileName, formatPDFTime } from './common/dateFormatter';
import { formatDate, formatTime, formatTimeStamp } from './common/dateFormatter';
import BurgerMenuComponent from './BurgerMenu.vue';
import BurgerMenuComponentPC from './BurgerMenuPc.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import SavingDialog from '@/components/SavingDialog.vue';
import ConsentDialog from './ConsentDialog.vue';
import {axiosClient} from '../utils/axiosClient';
import { useI18n } from 'vue-i18n';

export default {
  components: {
    BurgerMenuComponent,
    BurgerMenuComponentPC,
    SavingDialog,
    ConsentDialog,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const $toast = useToast();
    const { t } = useI18n();

    // PC画面幅管理用
    const isWideScreen = ref(window.innerWidth >= 600);

    const operatorId = ref('');
    const organizationId = ref(null);
    const measurement_type = ref(null);
    const audio_storage_flag = ref(null);
    const inspection_id = ref('');
    const subject_name = ref('');
    const subject_id = ref('');
    const gender = ref('');
    const age = ref(0);
    const measurements = ref([]);
    const startDateTime = ref('');
    const endDateTime = ref('');
    const oralFrailtys = ref([]);
    const analysisTypeFlag = ref (null);
    const useAnalaysisFlag = ref(false);
    // スクロールアイコン表示切り替え
    const isScrollFlag = ref(false);

    // その他の変数の初期化
    const measurementTypeText = ref('');
    const audioStorageText = ref('');
    const isShowResult = ref(false);
    const isModalVisible = ref(false);
    const isGeneratingPDF = ref(false);

    const isSaving = ref(false); //ダイヤログ表示フラグ
    const isEmergency = ref(false); //ダイヤログ表示内容指定フラグ
    // ダイアログ用のプロパティ
    const dialogTitle = computed(() => t('finish_dialog.title'));
    const dialogMessage = computed(() => t('finish_dialog.message'));
    const dialogApproval = computed(() => t('finish_dialog.yes_finish'));
    const dialogRejected = computed(() => t('finish_dialog.cancel'));
    const genderText = computed(() => {
      return gender.value === 1 
        ? t('subject.sex_male') 
        : gender.value === 2 
          ? t('subject.sex_female') 
          : gender.value === 3 
            ? t('subject.sex_other')  : t('subject.sex');
    });

    const showConsentDialog = ref(false);
    const currentMeasureType = ref('');

    // ストアからデータを取得
    const fetchData = () => {
      operatorId.value = store.getters['dataManagement/getOperatorId'];
      organizationId.value = store.getters['dataManagement/getOrganizationId'];
      measurement_type.value = store.getters['dataManagement/getMeasurementType'];
      audio_storage_flag.value = store.getters['dataManagement/getAudioStorageFlag'];
      inspection_id.value = store.getters['dataManagement/getInspectionId'];
      subject_id.value = store.getters['dataManagement/getSubjectId'];
      subject_name.value = store.getters['dataManagement/getResultName'];
      gender.value = store.getters['dataManagement/getGender'];
      age.value = store.getters['dataManagement/getAge'];
      measurements.value = store.getters['dataManagement/getMeasurements'];
      startDateTime.value = store.getters['dataManagement/getStartDateTime'];
      endDateTime.value = store.getters['dataManagement/getEndDateTime'];
      oralFrailtys.value = store.getters['dataManagement/getOralFrailtys'];
      analysisTypeFlag.value = store.getters['dataManagement/getAnalysisTypeFlag'];
      useAnalaysisFlag.value = store.getters['dataManagement/getisUseAnalaysis'];

      if (!startDateTime.value) {
        startDateTime.value = formatTimeStamp(new Date());
        store.dispatch('dataManagement/setStartDateTime', startDateTime.value);
      }
    };

    // パラメータの表示を更新するメソッド
    const updateDisplayParams = () => {
      measurementTypeText.value = measurement_type.value === '1' ? '5' : '10';
      audioStorageText.value = audio_storage_flag.value === '0' ? '保存する' : '保存しない';

      // パタカもしくはOF-5のいずれか一つでも実施済みの場合、isShowResult を true に設定
      if (measurements.value.some((measure) => measure.isCompleted) || oralFrailtys.value.some((measure) => measure.isCompleted)){
        isShowResult.value  = true;
      }

    };

    // 画面幅設定
    const updateScreenWidth = () => {
      isWideScreen.value = window.innerWidth >= 600;
    };

    // 画面幅スクロールアイコン表示処理
    const checkWindowHeight = () => {
      isScrollFlag.value = window.innerHeight <= 750;
    };

    // スクロール時に下部に到達したらスクロールアイコンを消す処理
    const checkScroll = () => {
      const scrollPosition = window.scrollY; // スクロールの現在位置
      const windowHeight = window.innerHeight; // 画面の高さ
      if (windowHeight > 750) {
        isScrollFlag.value = false;
      } else if ( (750 - windowHeight) >= scrollPosition) {
        isScrollFlag.value = true;
      }else{
        isScrollFlag.value = false;
      }
    }

    // コンポーネントがマウントされたときにデータを取得
    onMounted(() => {
      updateScreenWidth();
      window.addEventListener('resize', updateScreenWidth);
      // 画面の高さの監視
      checkWindowHeight();
      window.addEventListener('resize', checkWindowHeight);
      // スクロール時
      window.addEventListener('scroll', checkScroll);
      window.scrollTo(0, 0);
      fetchData();
      updateDisplayParams();
    });

    onBeforeUnmount(() => {
      // イベントリスナーのクリーンアップ
      window.removeEventListener('resize', updateScreenWidth);
      window.removeEventListener('resize', checkWindowHeight);
      window.removeEventListener('scroll', checkScroll);
    });

    // パ・タ・カ測定開始処理
    const handleMeasurement = async (measureType) => {

      currentMeasureType.value = measureType;
      console.log('currentMeasureType set to:', measureType);

      try {
        // 被験者IDの存在チェック
        const response = await axiosClient.get(`/api/consent/check/${subject_id.value}`);
        
        if (response.data.exists) {
          // 既に存在する場合は測定画面へ
          if (measureType === 'of') {
            router.push({
              name: 'ofQuestionExplanation',
              params: {
                operator_id: operatorId.value,
                measureWord: measureType,
              },
            });
          } else {
            router.push({
              name: 'explanation',
              params: { 
                operator_id: operatorId.value,
                measureWord: measureType
              }
            });
          }
        } else {
          // 存在しない場合は同意画面を表示
          showConsentDialog.value = true;
        }
      } catch (error) {
        console.error('被験者IDチェックエラー:', error);
        $toast.error(t('errors.subject_id_check'), { duration: 5000 });
      }
    };

    // パ・タ・カ・OF-5測定終了処理
    const handleShowResult = async () => {
      try {
        // 結果表示が有効な場合の処理
        if (isShowResult.value) {
          // 検査終了データを構築
          const updateData = {
            inspection_id: inspection_id.value,
            endDateTime: endDateTime.value,
          };
          // 各測定結果に対して、検査が完了している場合の処理
          for (const measure of measurements.value) {
            if (measure.isCompleted) {
              // 検査終了時刻の更新処理を実行
              let result = await store.dispatch('selectMenu/update', updateData);
              // 更新に失敗した場合エラーメッセージを表示
              if (!result.success) throw new Error(result.error);
            }
          }

          //レポート用一時保存から取得
          const measurementsData = store.getters['dataManagement/getMeasurementsData'];
          const oralFrailtysData = store.getters['dataManagement/getOralFrailtysData'];

          // console.log('measurementsData',measurementsData);

          // レポート出力用ストア保存用
          store.dispatch('dataManagement/setResultReportData',measurementsData);
          store.dispatch('dataManagement/setResultOf5Data',oralFrailtysData);

          // 結果ページに遷移 ※修正対象⇒印刷ページへ遷移
          router.push({
            name: 'result',
          });
        }
      } catch (error) {
        // エラーが発生した場合、エラーメッセージを表示
        $toast.error(error.message, { duration: 5000 });
      } finally {
        isGeneratingPDF.value = false;
      }
    };

    // 被検査者情報ページへ:確認ダイヤログ表示
    const handleSubject = async () => {
      isEmergency.value = true;
      isSaving.value = true;
    };

    // 検査者情報ページへ：ストア内容削除
    const handleDialogResponse = async (response) => {
      // ダイアログ非表示
      isEmergency.value = false;
      isSaving.value = false;
      if (response) {
        // 被検査者情報をクリアしてページ遷移
        await store.dispatch('dataManagement/clearSubject');
        router.push({
          name: 'subjectsRegist',
          params: { operator_id: operatorId.value }
        });
      }
    };

    // 測定設定の変更チェック
    const isSettingChanged = () => {
      const settingsChanged = measurement_type.value !== store.getters['dataManagement/getMeasurementType'] || analysisTypeFlag.value !== store.getters['dataManagement/getAnalysisTypeFlag'];
      return settingsChanged;
    };

    // 測定設定の更新APIへリクエスト
    const settingUpdate = async () => {
      try {
        // 設定が変更されている場合の処理
        if (isSettingChanged()) {
          // APIに送信するデータを構築し、測定設定を更新
          const updateData = {
            operator_id: operatorId.value,
            organization_id: organizationId.value,
            measurement_type: measurement_type.value,
            analysis_type_flag: analysisTypeFlag.value,
            is_use_analysis: useAnalaysisFlag.value,
          };
          await store.dispatch('dataManagement/setOperatorInfo', updateData);
        }
        // モーダルを閉じる
        toggleModal();
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('測定設定の更新に失敗しました:', error);
      }
    };

    // 設定変更をキャンセルする処理
    const cancelUpdate = async () => {
      try {
        // 設定変更前のデータを取得し、状態を元に戻す
        measurement_type.value = store.getters['dataManagement/getMeasurementType'];
        analysisTypeFlag.value = store.getters['dataManagement/getAnalysisTypeFlag'];
        // モーダルを閉じる
        toggleModal();
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('設定変更のキャンセルに失敗しました:', error);
      }
    };

    // モーダルの表示と非表示を切り替えるメソッド
    const toggleModal = () => {
      isModalVisible.value = !isModalVisible.value;
      // モーダルが閉じられたときに再描画をトリガー
      if (!isModalVisible.value) {
        updateDisplayParams();
      }
    };

    // 同意画面のレスポンスハンドラー
    const handleConsentResponse = async (hasConsented) => {
      console.log('handleConsentResponse', hasConsented);
      showConsentDialog.value = false;
      if (hasConsented) {
        try {
          // 同意情報を保存
          const response = await axiosClient.post('/api/consent', {
            operator_id: operatorId.value,
            subject_id: subject_id.value,
          });
          
          if (response.data.success) {
            // 同意情報の保存が成功したら測定画面へ
            if (currentMeasureType.value === 'of') {
              router.push({
                name: 'ofQuestionExplanation',
                params: {
                  operator_id: operatorId.value,
                  measureWord: currentMeasureType.value,
                },
              });
            } else {
              router.push({
                name: 'explanation',
                params: { 
                  operator_id: operatorId.value,
                  measureWord: currentMeasureType.value
                }
              });
            }
          } else {
            $toast.error(response.data.error || t('errors.consent_save_failed'), { duration: 5000 });
          }
        } catch (error) {
          console.error('同意情報保存エラー:', error);
          $toast.error(t('errors.consent_save_failed'), { duration: 5000 });
        }
      }
    };

    return {
      isWideScreen,
      operatorId,
      organizationId,
      measurement_type,
      audio_storage_flag,
      subject_name,
      subject_id,
      analysisTypeFlag,
      gender,
      age,
      measurements,
      oralFrailtys,
      startDateTime,
      endDateTime,
      genderText,
      measurementTypeText,
      audioStorageText,
      isShowResult,
      isModalVisible,
      isGeneratingPDF,
      isScrollFlag,
      toggleModal,
      handleMeasurement,
      handleShowResult,
      handleSubject,
      settingUpdate,
      cancelUpdate,
      isSaving,
      isEmergency,
      dialogTitle,
      dialogMessage,
      dialogApproval,
      dialogRejected,
      handleDialogResponse,
      useAnalaysisFlag,
      showConsentDialog,
      handleConsentResponse,
      formatDate, 
      formatTime, 
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';

.non-inspector-info-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>